var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38707 3.48639H4.17445C2.44714 3.48639 1.04688 4.88661 1.04688 6.61386V17.0389C1.04688 18.7661 2.44714 20.1663 4.17445 20.1663H14.5997C16.327 20.1663 17.7273 18.7661 17.7273 17.0389L17.7273 11.8264M6.25949 14.9538L10.0525 14.1895C10.2539 14.149 10.4388 14.0498 10.584 13.9045L19.0751 5.40907C19.4822 5.00176 19.4819 4.34153 19.0744 3.93456L17.2757 2.13793C16.8684 1.73113 16.2085 1.7314 15.8016 2.13855L7.30963 10.6349C7.16471 10.7799 7.06575 10.9644 7.02514 11.1653L6.25949 14.9538Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8f376c30f9b5b56a20132e21596a953e.svg";
export { ForwardRef as ReactComponent };